import { Card } from 'antd';
import styled from 'styled-components';

const Container = styled(Card)<{ fontSize: number; background: string }>`
    font-size: ${({ fontSize }) => fontSize}%;
    font-weight: bold;
    text-align: center;
    height: 100%;
    background: ${({ background }) => background} !important;

    .ant-card-head {
        border: none;
    }

    .ant-card-head-title {
        padding-bottom: 0;
        line-height: 1;
    }

    .ant-card-body {
        display: flex;
        flex-direction: column;
        font-size: ${({ fontSize }) => fontSize}%;
        font-weight: normal;
        height: 70%;
        vertical-align: top;
        padding: 0 10px;
    }

    .latex-wrapper {
        font-size: ${({ fontSize }) => fontSize * 0.9}%;
    }
`;

const WarningValue = styled.span<{ fontSize: number; color: string }>`
    font-family: sans-serif;
    font-size: ${({ fontSize }) => fontSize * 1.2}%;
    font-weight: bold;
    color: ${({ color }) => color};
    padding: 0;
    border-radius: 0;
`;

const CardContentWrapper = styled.div`
    margin: 2px 8px;
`;

const Heading = styled.h4<{ fontSize: number; colour: string }>`
    font-size: ${({ fontSize }) => fontSize * 0.8}%;
    color: ${({ colour }) => colour} !important;
    text-transform: uppercase;
    border-bottom: none;
    padding-bottom: 0.5em;
    margin-bottom: 0.5em;
`;

const CardContent = styled.div<{ fontSize: number; colour: string }>`
    font-size: ${({ fontSize }) => fontSize}%;
    color: ${({ colour }) => colour} !important;
`;

const Title = styled.div`
    width: 100%;
    margin: 0 auto;
`;

export { CardContent, CardContentWrapper, Container, Heading, Title, WarningValue };
